var _path, _line, _line2, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4999 14C27.4999 21.4558 21.4557 27.5 13.9999 27.5C6.54413 27.5 0.5 21.4558 0.5 14C0.5 6.54415 6.54413 0.5 13.9999 0.5C21.4557 0.5 27.4999 6.54415 27.4999 14Z",
    stroke: "#F44434"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.875,
    y1: 13.5,
    x2: 27.9999,
    y2: 13.5,
    stroke: "#F44434"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.375,
    y1: 27.125,
    x2: 14.375,
    y2: -2.18558e-8,
    stroke: "#F44434"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4460_2719",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4307 27.9933C21.9602 27.7622 27.9932 21.5856 27.9932 14C27.9932 6.26801 21.7252 0 13.9932 0C6.40765 0 0.231128 6.03295 0 13.5625H14.4307V27.9933Z",
    fill: "white",
    fillOpacity: 0.7
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4460_2719)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 5.25,
    width: 0.437498,
    height: 10.5,
    fill: "#F44434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.9375,
    y: 3.5,
    width: 0.437498,
    height: 10.5,
    fill: "#F44434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.125,
    y: 1.75,
    width: 0.437498,
    height: 12.25,
    fill: "#F44434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.3125,
    y: 1.75,
    width: 0.437498,
    height: 12.25,
    fill: "#F44434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: -2.625,
    width: 0.437499,
    height: 16.625,
    fill: "#F44434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6875,
    y: -2.625,
    width: 0.437498,
    height: 16.625,
    fill: "#F44434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.875,
    y: -2.625,
    width: 0.437499,
    height: 16.625,
    fill: "#F44434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.0625,
    y: -2.625,
    width: 0.437498,
    height: 32.375,
    fill: "#F44434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.25,
    y: -2.625,
    width: 0.4375,
    height: 32.375,
    fill: "#F44434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4375,
    y: -2.625,
    width: 0.437498,
    height: 32.375,
    fill: "#F44434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.625,
    y: -2.625,
    width: 0.437498,
    height: 32.375,
    fill: "#F44434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.8125,
    y: -2.625,
    width: 0.437498,
    height: 32.375,
    fill: "#F44434"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanIcons);
export default __webpack_public_path__ + "static/media/PlanIcons.3299e293ccba44513f955f395a6f61dc.svg";
export { ForwardRef as ReactComponent };